import * as THREE from 'three';
import {item} from './item';

type editItemTypename = "item_edit";

export type objectDataType = {
    "guid": string;
    "code": string;
    "idthreed": string;
    "translate": number[];
    "rotation": number[];
    "scale": number[];
    "layer": any;
    "index": any;
    "reverse": any;
};

type pscommand<T> = {
    "type": T extends editItemTypename ? T : never;
    "data": T extends editItemTypename ? objectDataType : never;
};

export type editItemCommand = pscommand<editItemTypename>;

export class editItem extends item {
    public type: editItemTypename = "item_edit";

    constructor(data: THREE.Object3D) {
        super(data);
    }

    protected objectData(): objectDataType {
        const modelinfo = this.data.userData.modelInfo;
        const position = this.data.getWorldPosition(new THREE.Vector3());
        const scale = this.data.getWorldScale(new THREE.Vector3());

        const code = modelinfo.code;
        const idthreed = (modelinfo.idthreed && modelinfo.idthreed != '') ? modelinfo.idthreed : '';

        return {
            "guid" : modelinfo.uuid,
            "code": code,
            "idthreed": idthreed,
            "translate": [position.x, position.y, position.z],
            "rotation": [this.data.rotation.x, this.data.rotation.y, this.data.rotation.z],
            "scale": [scale.x, scale.y, scale.z],
            "layer": modelinfo.layer,
            "index": modelinfo.index,
            "reverse": modelinfo.reverse
        }
    }

    public object(): editItemCommand {
        return {
            "type" : this.type,
            "data" : this.objectData()
        }
    }
}
